import BrandList from "@/components/brand/list/BrandList";
import BrandInfo from "@/components/brand/info/BrandInfo";
import BrandSemantics from "@/components/brand/semantics/Semantics";
import BrandSemanticst from "@/components/brand/semanticst/Semantics";
import BrandProducts from "@/components/brand/products/Products";
import BrandCountry from "@/components/brand/country/Country";
import BrandDynamics from "@/components/brand/dynamics/Dynamics";
import BrandPosition from "@/components/brand/position/Position";
import BrandDescriptions from "@/components/brand/descriptions/Descriptions";
import BrandContent from "@/components/brand/content/BrandContent";
import BrandError from "@/components/brand/error/BrandError.vue";

export const brandRouter = [
    {path: '/', name: 'brand', component: BrandList},
    {path: '/brand-info/:id', name: 'brandInfo', component: BrandInfo},
    {path: '/brand-content/:id', name: 'brandContent', component: BrandContent},
    {path: '/brand-error/:id', name: 'brandError', component: BrandError},
    {path: '/brand-semantics/:id', name: 'brandSemantics', component: BrandSemantics},
    {path: '/brand-semanticst/:id', name: 'brandSemanticst', component: BrandSemanticst},
    {path: '/brand-products/:id', name: 'brandProducts', component: BrandProducts},
    {path: '/brand-country/:id', name: 'brandCountry', component: BrandCountry},
    {path: '/brand-dynamics/:id', name: 'brandDynamics', component: BrandDynamics},
    {path: '/brand-position/:id', name: 'brandPosition', component: BrandPosition},
    {path: '/brand-descriptions/:id', name: 'brandDescriptions', component: BrandDescriptions},
]